
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import SidemenuLayout from '@/components/organisms/layout/SidemenuLayout.vue'
import SelectStudyCategoryMainPanel from '@/components/organisms/SelectStudyCategoryMainPanel.vue'
import ProgressFilterPulldown from '@/components/organisms/ProgressFilterPulldown.vue'
import SelectStudyCategoryContent from '@/components/organisms/SelectStudyCategoryContent.vue'
import { StudyCategoryCurriculumUnit } from '@/models/CurriculumUnit'

/**
 * 学習教材選択ページレイアウト
 */
@Component({
  components: {
    SidemenuLayout,
    SelectStudyCategoryMainPanel,
    ProgressFilterPulldown,
    SelectStudyCategoryContent,
  },
})
export default class SelectStudyCategoryContentList extends Vue {
  /** 学習進捗プルダウン */
  @Ref()
  progressFilterPulldown!: ProgressFilterPulldown

  /** メインパネル用画像URL */
  @Prop()
  private textbookImagePath!: string | null

  /** 学習教材選択ボタン押下時のイベント */
  @Prop()
  private onSelectStudyCategoryButton!: () => void

  /** 学習進捗絞り込みコードの初期値 */
  @Prop()
  private defaultProgressFilterCode!: string

  /** 学習状況付き単元情報のリスト */
  @Prop()
  private studyCategoryCurriculumUnitList!: StudyCategoryCurriculumUnit[]

  /** 学習教材に紐づく単元の数 */
  @Prop()
  private curriculumUnitCount!: number

  /** 単元パネルクリック時のイベント */
  @Prop()
  private eventClickCurriculumUnit!: (curriculumUnitId: number) => void

  /**
   * 選択中の学習進捗コード
   *
   * @returns 学習進捗のコード
   */
  public currentProgressFilterCode(): string {
    // DOM未処理によるundefinedブロック
    if (!this.progressFilterPulldown) {
      return ''
    }
    return this.progressFilterPulldown.selectedValue()
  }
}
